import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ESignDashboard from './pages/esign/ESignDashboard';
import PDFEditor from './pages/esign/PDFEditor';
import SendDocument from './pages/esign/SendDocument';
import SignPage from './pages/esign/SignPage';
import SignatureBuilder from './pages/email-signatures/SignatureBuilder';
import Templates from './pages/email-signatures/Templates';
import SocialBuilder from './pages/SocialBuilder';
import AIImages from './pages/AIImages';
import Texting from './pages/Texting';
import AdminPanel from './pages/AdminPanel';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppContent() {
  const { user } = useAuth();
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
            <Route path="/register" element={user ? <Navigate to="/dashboard" /> : <Register />} />
            <Route path="/sign/:token" element={<SignPage />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/esign" element={<PrivateRoute><ESignDashboard /></PrivateRoute>} />
            <Route path="/esign/editor/:docId" element={<PrivateRoute><PDFEditor /></PrivateRoute>} />
            <Route path="/esign/send/:docId" element={<PrivateRoute><SendDocument /></PrivateRoute>} />
            <Route path="/email-signatures" element={<PrivateRoute><SignatureBuilder /></PrivateRoute>} />
            <Route path="/email-signatures/templates" element={<PrivateRoute><Templates /></PrivateRoute>} />
            <Route path="/social" element={<PrivateRoute><SocialBuilder /></PrivateRoute>} />
            <Route path="/ai-images" element={<PrivateRoute><AIImages /></PrivateRoute>} />
            <Route path="/texting" element={<PrivateRoute><Texting /></PrivateRoute>} />
            <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
